import React, { Component } from 'react'
import Icon from './Icon'

interface SidebarCloseProps {
  onClick: () => void
}

export default class SidebarClose extends Component<SidebarCloseProps> {
  render () {
    return (
      <Icon
        name="close"
        size="large"
        color="white"
        className="block sm:hidden"
        onClick={this.props.onClick} />
    )
  }
}
